import React, { useState } from 'react';
import { useLanguage } from '../components/LanguageContext';
import '../styles/Contact.css';

const Contacto: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const { language } = useLanguage(); // Obtén el idioma actual

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Lógica para manejar el envío del formulario aquí
    console.log('Formulario enviado:', formData);
    // Puedes agregar la lógica para enviar los datos del formulario a tu backend u realizar otras acciones necesarias
  };

  return (
    <div className="login-box" id="contact-content">
      {/* Utiliza el idioma actual para mostrar el título */}
      <h2>{language === 'es' ? 'Contacto' : 'Contact'}</h2>
      <div className="contact-links">
        <a href="mailto:angelocentellas@gmail.com">
          <img className="contact-image" src="/gmail.png" alt="Gmail" />
        </a>
        <a href="https://www.linkedin.com/in/angelo-herrera-centellas-a56711233/" target="_blank" rel="noopener noreferrer">
          <img className="contact-image" src="/linkedin.png" alt="LinkedIn" />
        </a>
        <a href="https://github.com/AnGeMoNs" target="_blank" rel="noopener noreferrer">
          <img className="contact-image" src="/github.png" alt="GitHub" />
        </a>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="user-box">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          {/* Utiliza el idioma actual para mostrar la etiqueta del campo */}
          <label>{language === 'es' ? 'Nombre' : 'Name'}</label>
        </div>

        <div className="user-box">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          {/* Utiliza el idioma actual para mostrar la etiqueta del campo */}
          <label>{language === 'es' ? 'Correo Electrónico' : 'Email'}</label>
        </div>

        <div className="user-box">
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
          {/* Utiliza el idioma actual para mostrar la etiqueta del campo */}
          <label>{language === 'es' ? 'Asunto' : 'Subject'}</label>
        </div>

        <div className="user-box">
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows={5}
            // Utiliza el idioma actual para mostrar el marcador de posición del área de texto
            placeholder={language === 'es' ? 'Ingresa tu mensaje aquí' : 'Enter your message here'}
            required
          />
        </div>

        {/* Utiliza el idioma actual para mostrar el botón de envío */}
        <button type="submit">{language === 'es' ? 'Enviar' : 'Submit'}</button>
      </form>
    </div>
  );
};

export default Contacto;

